import React, { useMemo } from 'react';
import { useDropzone } from 'react-dropzone';

const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    cursor: 'pointer'
};

const activeStyle = {
    borderColor: '#2196f3'
};

const acceptStyle = {
    borderColor: '#2798fb'
};

const rejectStyle = {
    borderColor: '#2798fb'
};

const fileStyle = {
    borderColor: '#00e676'
};

const StyledDropzone = (props) => {
    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject,
        acceptedFiles
    } = useDropzone({ ...props });

    const style = useMemo(() => ({
        ...baseStyle,
        ...(isDragActive ? activeStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {}),
        ...(!!acceptedFiles[0] ? fileStyle : {})
    }), [
        isDragActive,
        isDragReject,
        isDragAccept,
        acceptedFiles
    ]);

    return (
        <div className={props.className}>
            <div {...getRootProps({ style })}>
                <input {...getInputProps()} />
                {props.children}
            </div>
        </div>
    );
}

export default StyledDropzone;